/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChineseWaybillVo
 */
export interface ChineseWaybillVo {
    /**
     * 运单号
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    ivcNo?: string;
    /**
     * 当前时间
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    now?: string;
    /**
     * 订单号
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    orderCode?: string;
    /**
     * 收货地址
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    receiveAddress?: string;
    /**
     * 收货地址详情
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    receiveAddressDetail?: string;
    /**
     * 手机号
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    mobileNo?: string;
    /**
     * 收货人姓名
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    receiveNameKr?: string;
    /**
     * 总箱数
     * @type {number}
     * @memberof ChineseWaybillVo
     */
    totalBoxCount?: number;
    /**
     * 收货要求
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    receiverDeliveryRequirement?: string;
    /**
     * 收货要求（韩文）
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    receiverDeliveryRequirementKr?: string;
    /**
     * 国际运输方式ID
     * @type {number}
     * @memberof ChineseWaybillVo
     */
    internationalTransportMethodId?: number;
    /**
     * 子运单号
     * @type {Array<string>}
     * @memberof ChineseWaybillVo
     */
    subIvcNo?: Array<string>;
    /**
     * 主运单面单打印份数：海运且有子运单时等于运单数（主+子总数，主面单每箱一份），其余场景为1；子运单面单按subIvcNo各打印一份
     * @type {number}
     * @memberof ChineseWaybillVo
     */
    mainPrintCount?: number;
    /**
     * cj单号
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    jcCode?: string;
    /**
     * cj数据1
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    dlvPreArrBranShortNm?: string;
    /**
     * cj数据2
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    dlvPreArrEmpNickNm?: string;
    /**
     * cj权역名（如：인천권역）
     * @type {string}
     * @memberof ChineseWaybillVo
     */
    dlvPreArrBranNm?: string;
}

/**
 * Check if a given object implements the ChineseWaybillVo interface.
 */
export function instanceOfChineseWaybillVo(value: object): value is ChineseWaybillVo {
    return true;
}

export function ChineseWaybillVoFromJSON(json: any): ChineseWaybillVo {
    return ChineseWaybillVoFromJSONTyped(json, false);
}

export function ChineseWaybillVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChineseWaybillVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ivcNo': json['ivcNo'] == null ? undefined : json['ivcNo'],
        'now': json['now'] == null ? undefined : json['now'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'receiveAddress': json['receiveAddress'] == null ? undefined : json['receiveAddress'],
        'receiveAddressDetail': json['receiveAddressDetail'] == null ? undefined : json['receiveAddressDetail'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'receiveNameKr': json['receiveNameKr'] == null ? undefined : json['receiveNameKr'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
        'receiverDeliveryRequirement': json['receiverDeliveryRequirement'] == null ? undefined : json['receiverDeliveryRequirement'],
        'receiverDeliveryRequirementKr': json['receiverDeliveryRequirementKr'] == null ? undefined : json['receiverDeliveryRequirementKr'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'subIvcNo': json['subIvcNo'] == null ? undefined : json['subIvcNo'],
        'mainPrintCount': json['mainPrintCount'] == null ? undefined : json['mainPrintCount'],
        'jcCode': json['jcCode'] == null ? undefined : json['jcCode'],
        'dlvPreArrBranShortNm': json['dlvPreArrBranShortNm'] == null ? undefined : json['dlvPreArrBranShortNm'],
        'dlvPreArrEmpNickNm': json['dlvPreArrEmpNickNm'] == null ? undefined : json['dlvPreArrEmpNickNm'],
        'dlvPreArrBranNm': json['dlvPreArrBranNm'] == null ? undefined : json['dlvPreArrBranNm'],
    };
}

export function ChineseWaybillVoToJSON(json: any): ChineseWaybillVo {
    return ChineseWaybillVoToJSONTyped(json, false);
}

export function ChineseWaybillVoToJSONTyped(value?: ChineseWaybillVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ivcNo': value['ivcNo'],
        'now': value['now'],
        'orderCode': value['orderCode'],
        'receiveAddress': value['receiveAddress'],
        'receiveAddressDetail': value['receiveAddressDetail'],
        'mobileNo': value['mobileNo'],
        'receiveNameKr': value['receiveNameKr'],
        'totalBoxCount': value['totalBoxCount'],
        'receiverDeliveryRequirement': value['receiverDeliveryRequirement'],
        'receiverDeliveryRequirementKr': value['receiverDeliveryRequirementKr'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'subIvcNo': value['subIvcNo'],
        'mainPrintCount': value['mainPrintCount'],
        'jcCode': value['jcCode'],
        'dlvPreArrBranShortNm': value['dlvPreArrBranShortNm'],
        'dlvPreArrEmpNickNm': value['dlvPreArrEmpNickNm'],
        'dlvPreArrBranNm': value['dlvPreArrBranNm'],
    };
}

